var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.08936,
    width: 10.0907,
    height: 10.0912,
    rx: 2,
    transform: "rotate(11.95 2.08936 0)",
    fill: "#E7E9F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9087,
    y: 0.935547,
    width: 10.0906,
    height: 10.0912,
    rx: 2,
    fill: "#E7E9F1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.935303,
    y: 13.9092,
    width: 10.0906,
    height: 10.0912,
    rx: 2,
    fill: "#E7E9F1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9094,
    y: 13.9092,
    width: 10.0906,
    height: 10.0912,
    rx: 2,
    fill: "#E7E9F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubSolid);
export default __webpack_public_path__ + "static/media/hubSolid.f7092c7bb34dd35eadd49e435ae09c1c.svg";
export { ForwardRef as ReactComponent };